import React, {useState, useRef, useEffect, Fragment} from 'react';
import {LazyImage, OnlineAddress, OnlineMedAddress} from "../../../Components";
import {convertRialToToman, detectEnglishLang, numberWithCommas} from "../../../Services";
import uploadLogo from "../../../assets/images/upload_icon.svg";
import plusIcon from "../../../assets/images/plaus_icon.png";
import {DeleteOutlined,PlusOutlined} from '@ant-design/icons';
import {message, Popconfirm,Modal,Spin,Collapse} from 'antd';
import moment from "moment-jalaali";
import Expand from 'react-expand-animated';
import {
    createmedOrder_api,
    finialMedOrder_api,
    getAddressList_api, getAddressMedOrder_api,
    getMallMerchant_api,
    getMeds_api
} from "../../../Services/apis";
import {StoreOnlineCreateInvoice} from "../../Payment/PaymentService";
import { Pagination } from 'antd';
import {useHistory} from "react-router";

import GreenBasketIcon from "../../../assets/images/green_basket-icon.png"
import GreenPlusIcon from "../../../assets/images/green_plus_icon.png"
import SmallGreenBasketIcon from "../../../assets/images/small_green_basket.png"
import CapDrugIcon from "../../../assets/images/cap_drugs_icon.png"
import TabDrugIcon from "../../../assets/images/drug_icon.png"
import PhUploadIcon from "../../../assets/images/ph_upload-icon.png"
import TrashIcon from "../../../assets/images/trash-icon.png"
import SwiperId from "react-id-swiper";
import Zoom from "react-medium-image-zoom";
import {ChangeDefaultMedAddress} from "../../../Components/OnlineMedAddress/OnlineMedAddressService";

let page = 1
let merchantId = ""

const { Panel } = Collapse;


const imageParamss = {
    slidesPerView: 4,
    spaceBetween: 5,
    rtl:true,
    pagination: {
        el: '.swiper-pagination',
        clickable: true
    },
    breakpoints: {
        1024: {
            slidesPerView: 8,
            spaceBetween: 20
        },
        768: {
            slidesPerView: 8,
            spaceBetween: 20
        },
        400: {
            slidesPerView: 'auto',
            spaceBetween: 8
        },
        320: {
            slidesPerView: 'auto',
            spaceBetween: 8
        }
    }

}


// drug_name: drug_name,
//     drug_count: drug_count,
//     drug_unit: drug_unit,
//     drug_type: drug_type,
//     drug_dose: drug_dose

const remember_list =[
    {drug_name:"چسب زخم",drug_count:1,drug_unit:"بسته",drug_type:"سایر",drug_dose:"",image:"https://dl.oneteb.com/uploads/2020/07/FirstAidPlaster-1.jpg"},
    {drug_name:"قرص جوشان",drug_count:1,drug_unit:"ورق",drug_type:"قرص",drug_dose:"",image:"https://dkstatics-public.digikala.com/digikala-products/56e275dac1648915a8eb621ed818890220ae5608_1602679367.jpg?x-oss-process=image/resize,m_lfit,h_800,w_800/quality,q_90"},
    {drug_name:"نووافن",drug_count:1,drug_unit:"ورق",drug_type:"قرص",drug_dose:"",image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTrRLry9SjbsKq9Gz31x_S6tAxnvnJp4zbivwIn87WOig&s"},
    {drug_name:"ژلوفن",drug_count:1,drug_unit:"ورق",drug_type:"قرص",drug_dose:"",image:"https://image.torob.com/base/images/3z/0X/3z0X1AKLvXjW5VOy.png_/560x560.webp"},
    {drug_name:"بی بی چک",drug_count:1,drug_unit:"سایر",drug_type:"سایر",drug_dose:"",image:"https://daroohelp.com/wp-content/uploads/2022/05/30.jpg"},
    {drug_name:"سرما خوردگی بزرگسالان",drug_count:1,drug_unit:"ورق",drug_type:"قرص",drug_dose:"",image:"https://cdn3.goldtag.net/web/uploads/pictures/558x405/1620105590_1569680353__750-5443.jpg"},
]

const convertStatusCode = (code) =>{
    let result =""
    switch (code) {
        case 1:
            result  =  "اولیه"
            break;
        case 2:
            result  =  "آماده پرداخت"
            break;
        case 3:
            result  =  "پرداخت شده"
            break;
        case 5:
            result  =  "رد شده توسط صندوقدار"
            break;
        case 9:
            result  =  "شروع جمع آوری"
            break;
        case 10:
            result  =  "جمع آوری شده"
            break;
        case 13:
            result  =  "آماده ارسال"
            break;
        case 14:
            result  =  "در حال پیدا کردن پیک"
            break;
        case 15:
            result  =  "قبول شده توسط پیک"
            break;
        case 20:
            result  =  "در حال ارسال"
            break;
        case 25:
            result  =  "تحویل شده"
            break;
        case 30:
            // result  =  "توسط مشتری لغو شد"
            result  =  " لغو شد"
            break;
        case 31:
            result  =  " لغو شد"
            // result  =  "توسط داروخانه لغو شد"
            break;
        case 32:
            result  =  "توسط میاره لغو شد"
            break;
    }

    return result;

}



const OTC_card = ({e,change}) => {



    return (
        <div className="med-detail-modal-item">
            <div className="med-detail-modal-item-info">
                <span>{e.name}</span>
            </div>
            <div className="med-detail-modal-item-form">
                <div className="med-detail-modal-item-form-price">
                    <span>  {numberWithCommas(e.discount)} تخفیف (ریال)  </span>
                    <span>  {numberWithCommas(e.price)} قیمت (ریال) </span>
                </div>

                <div className="med-detail-modal-item-form-desc">
                               <p>{e.description}</p>
                </div>
            </div>
        </div>
    )
}


const FP_card = ({e,change}) => {



    return (
        <div className="med-detail-modal-item">
            <div className="med-detail-modal-item-info">
                <img src={e.file} alt=""/>
            </div>
            <div className="med-detail-modal-item-form">
                <div className="med-detail-modal-item-form-price">
                    <span>  {numberWithCommas(e.discount)} تخفیف (ریال)  </span>
                    <span>  {numberWithCommas(e.price)} قیمت (ریال) </span>
                </div>

                <div className="med-detail-modal-item-form-desc">
                    {e.description}
                </div>
            </div>
        </div>
    )
}


// e_prescription
// files
// otc


const EP_card = ({e}) => {

    return (
        <div className="med-detail-modal-item">
            <div className="med-detail-modal-item-info">
                <span>{`کد ملی : ${e.national_code}/کد رهگیری :${e.prescription_id}/نام پزشک :${e.dr_name}`}</span>
            </div>
            <div className="med-detail-modal-item-form">
                <div className="med-detail-modal-item-form-price">
                    <span>  {numberWithCommas(e.discount)} تخفیف (ریال)  </span>
                    <span>  {numberWithCommas(e.price)} قیمت (ریال) </span>
                </div>

                <div className="med-detail-modal-item-form-desc">
                                <p>{e.description}</p>
                </div>
            </div>
        </div>
    )
}


function makeid(length) {
    let result = '';
    const characters = '0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
}


const MedC = ({med}) => {

    const items = []


    return (
        <div className="med-detail-modal-body-desc">


            {med.e_prescription.map(e => {
                return (
                    <EP_card e={e} />
                )
            })}

            {med.files.map(e => {
                return (
                    <FP_card e={e} />
                )
            })}


            {med.otc.map(e => {
                return (
                    <OTC_card e={e} />
                )
            })}

        </div>
    )
}


const convertTicketStatus = (status)=>{
    switch(status){
        case 1:
            return "در حال بررسی"
            break;
        case 2:
            return "تایید شده"
            break;
        case 3:
            // return "تایید شده توسط مشتری"
            return "منتظر پرداخت"
            break;
        case 4:
            return "پرداخت شده"
            break;
        case 5:
            return "رد شده"
            break;
    }
}


const convertOrderStatusColor = (status)=>{
    switch(status){
        case 1:
            return "#F5B554"
            break;
        case 2:
            return "#279A40"
            break;
        case 3:
            return "#279A40"
            break;
        case 4:
            return "#279A40"
            break;
        case 5:
            return "#ea6c6c"
            break;
    }
}


const convertTicketStatusColor = (status)=>{
    switch(status){
        case 1:
            return "#F5B554"
            break;
        case 2:
            return "#279A40"
            break;
        case 3:
            return "#39e4f3"
            break;
        case 4:
            return "#279A40"
            break;
        case 5:
            return "#ea6c6c"
            break;
    }
}


function parseOtc(st) {
    let arr = st.split("/");
    let d_name = arr[0].split(":")[1]
    let d_count = arr[1].split(":")[1]
    let d_unit = arr[2].split(":")[1]
    let d_type = arr[3].split(":")[1]
    let d_dose = arr[4].split(":")[1]
    let d_desc = arr[5].split(":")[1]
    return {d_name,d_count,d_unit,d_type,d_dose,d_desc}
}


function FollowCard({p,mId}){

    const [max,set_max] = useState([])
    const [expandStatus,set_expandStatus] = useState(false)

    useEffect(()=>{
       maxCount(p)
    },[])

    const maxCount =(p)=>{
        let otc_count = p.otc.length;
        let e_count = p.e_prescription.length;
        let files_count = p.files.length;
        let maximum = Math.max(otc_count, e_count, files_count);
        set_max([...Array(maximum).keys()])
    }


    console.log("gener :",p)

    const [currentDetail, set_currentDetail] = useState({});
    const [spin, set_spin] = useState(false);
    const [isCouponModalVisible, setIsCouponModalVisible] = useState(false);

    const history = useHistory()

    const showModal = () => {
        setIsCouponModalVisible(true);
    };

    const handleOk = () => {
        setIsCouponModalVisible(false);
    };

    const handleCancel = () => {
        setIsCouponModalVisible(false);
    };


    const finalizedMed = async (p)=> {

        //set address

        let non_delivery = deliverType==="none"

        try{
            const res = await finialMedOrder_api(p.uid,non_delivery)

            let f = res.data.invoice;

            try {
                //create invoice
                let req = {
                    amount: f.payable_amount,
                    client_callback: window.location.origin+"/dr-shop/bank-result/"+f.uid,
                    res_num: f.uid,
                    merchant_uid: f.merchant.uid
                }
                const response = await StoreOnlineCreateInvoice(req);
                history.push(`/dr-shop/pay/${f.merchant.uid}`, {create: response.data,finalObj:{invoice:f}})
                // history.push(`/dr-shop/preinvoice/${f.merchant.uid}`, {create: response.data})
            } catch (e) {
                // console.log(e)
                return
            }

        }catch (e) {

            console.log(e)
        }

    }

    // const directPay = async (f)=>{
    //     console.log("f",f)
    //
    //     try {
    //         //create invoice
    //         let req = {
    //             amount: f.payable_amount,
    //             client_callback: window.location.origin+"/dr-shop/bank-result/"+f.uid,
    //             res_num: f.uid,
    //             merchant_uid: f.merchant.uid
    //         }
    //         const response = await StoreOnlineCreateInvoice(req);
    //         history.push(`/dr-shop/pay/${f.merchant.uid}`, {create: response.data,finalObj:{invoice:f}})
    //         // history.push(`/dr-shop/preinvoice/${f.merchant.uid}`, {create: response.data})
    //     } catch (e) {
    //         // console.log(e)
    //         return
    //     }
    // }


    const [deliverType,set_deliverType] = useState("courier")


    return(
        <div className="follow-card">

            <Modal visible={isCouponModalVisible}  footer={null}   onOk={handleOk} onCancel={handleCancel}>


                <Spin spinning={spin}>
                    <div className="request-detail-modal">
                        <div className="request-detail-modal-header">
                            <div className="request-detail-modal-header-title" >
                                <span>آدرس : </span>
                            </div>
                            <span>{p.address}</span>
                        </div>

                        <div className="request-detail-modal-header">
                            <div className="request-detail-modal-header-title" >
                                <span>نوع تحویل را انتخاب نمایید : </span>
                            </div>
                            <div className="deliver-sec">

                                <div className="deliver-item" onClick={e=>{set_deliverType("none")}}>
                                    <span>حضوری</span>
                                    <input type="radio" name="delivery" id="" placeholder="" checked={deliverType==="none"}/>
                                </div>

                                <div className="deliver-item" onClick={e=>{set_deliverType("courier")}}>
                                    <span>پیک</span>
                                    <input type="radio" name="delivery" id="" placeholder="" checked={deliverType==="courier"}/>
                                </div>

                            </div>


                        </div>

                        <div className="request-detail-modal-body">
                            <MedC med={p}/>
                        </div>

                        <div className="med-detail-modal-footer">


                            <div className="med-detail-modal-footer-row">
                                <span className="med-detail-modal-footer-row-value">{numberWithCommas(p.total_discount)} ریال</span>
                                <span className="med-detail-modal-footer-row-label">تخفیف </span>
                            </div>

                            <div className="med-detail-modal-footer-row">
                                <span className="med-detail-modal-footer-row-value">{numberWithCommas(p.tech_cost)} ریال</span>
                                <span className="med-detail-modal-footer-row-label">حق فنی </span>
                            </div>


                            <div className="med-detail-modal-footer-row">
                                <span className="med-detail-modal-footer-row-value">{numberWithCommas(p.total_amount)} ریال</span>
                                <span className="med-detail-modal-footer-row-label">مبلغ قابل پرداخت</span>
                            </div>

                        </div>



                        <div className="med-detail-modal-footer-btns">
                            <div className="med-detail-modal-footer-btn-accept" onClick={e=>{
                                finalizedMed(p)
                            }}>
                                <span>مشاهده فاکتور</span>
                            </div>
                            {/*<div className="med-detail-modal-footer-btn-reject" onClick={e=>{*/}
                            {/*    // rejectMedOrder()*/}
                            {/*}}>*/}
                            {/*    <span>رد کردن</span>*/}
                            {/*</div>*/}
                        </div>

                    </div>
                </Spin>


            </Modal>
            <div className="follow-card-header">




              <div className="follow-card-header-row">


                  {p.order_status && p.order_status[0] && p.order_status[0]>2?
                      <div></div>
                      :
                      <div>
                          {p.status===2 || p.status===3?
                              <div className="follow-card-header-price">
                                  <div className="follow-card-header-price-btn clickable" onClick={e=>{
                                      finalizedMed(p)
                                  }}>
                                      <span>پرداخت</span>
                                  </div>
                                  <div className="follow-card-header-price-label">
                                      <span className="follow-card-header-price-label-value">{numberWithCommas(p.total_amount)}</span>
                                      <span className="follow-card-header-price-label-text">مبلغ کل (ریال)</span>
                                  </div>

                              </div>
                              :null}
                      </div>
                  }



                  {p.order_status && p.order_status[0] && p.order_status[0]>2?
                      <div></div>:
                  <div className="follow-card-header-cancel clickable">
                      <span>لغو سفارش</span>
                  </div>}

                  {p.order_status && p.order_status[0] && p.order_status[0]>2?
                      <div className="follow-card-header-status" style={{backgroundColor:convertOrderStatusColor(p.order_status[0])}}>
                              <span   className="follow-card-header-status-value">{convertStatusCode(p.order_status[0])}</span>
                          <span className="follow-card-header-status-label">وضعیت : </span>
                      </div>
                      :
                      <div className="follow-card-header-status" style={{backgroundColor:convertTicketStatusColor(p.status)}}>
                              <span   className="follow-card-header-status-value">{convertTicketStatus(p.status)}</span>
                          <span className="follow-card-header-status-label">وضعیت : </span>
                      </div>
                  }



                  <div className="follow-card-header-date">
                      <span>{moment(
                          p.created
                      ).format(
                          "jYYYY/jMM/jDD  HH:mm"
                      )}</span>
                      <span>{p.id}</span>
                      <span>شماره سفارش</span>
                  </div>
              </div>

                <div className="follow-card-header-row">
                    <div className="follow-card-header-row-description">
                        <span>توضیحات مسئول فنی : </span>
                        <span>{p.description}</span>
                    </div>
                </div>

                <div className="follow-card-header-row">
                    <div className="follow-card-header-row-last">

                        <div className="follow-card-header-row-last-item green-item">
                            <span>تخفیف روی سبد سفارش : </span>
                            <span>{numberWithCommas(p.total_discount)} تومان</span>
                        </div>

                        <div className="follow-card-header-row-last-item red-item">
                            <span>حق فنی : </span>
                            <span>{numberWithCommas(p.tech_cost)} تومان</span>
                        </div>

                        {p.non_delivery?
                            <div className="follow-card-header-row-last-item red-item">
                                <span>حضوری</span>
                            </div>:
                            <div className="follow-card-header-row-last-item red-item">
                                <span>پیک : </span>
                                <span>{p.merchant_courier}</span>
                            </div>
                        }



                    </div>
                </div>

            </div>

            <div className="see-detail">
                <span className="clickable" onClick={e=>{
                    set_expandStatus(!expandStatus)
                }}>مشاهده جزییات سفارش</span>
            </div>
            <Expand open={expandStatus} >
                <div className="follow-card-body">


                    <div className="follow-card-body-row-head">

                        <div className="follow-card-body-header-col">
                            <div className="follow-card-body-header-col-header">
                                <span>داروی بدون نسخه</span>
                            </div>
                        </div>

                        <div className="follow-card-body-header-col">
                            <div className="follow-card-body-header-col-header">
                                <span>نسخه کاغذی</span>
                            </div>
                        </div>

                        <div className="follow-card-body-header-col">
                            <div className="follow-card-body-header-col-header">
                                <span>نسخه الکترونیک</span>
                            </div>
                        </div>

                    </div>


                    {max.map((m,index)=>{
                        return(
                            <div className="follow-card-body-row">

                                <div className="follow-card-body-header-col">
                                    {p.otc[index]?<div className="follow-card-body-header-col-body">

                                        <div className="follow-card-body-header-col-body-item">
                                            <span className="follow-card-body-header-col-body-value">{parseOtc(p.otc[index].name).d_name}</span>
                                            <span className="follow-card-body-header-col-body-label">نام دارو</span>
                                        </div>

                                        <div className="follow-card-body-header-col-body-item">
                                            <span className="follow-card-body-header-col-body-value">{parseOtc(p.otc[index].name).d_type}</span>
                                            <span className="follow-card-body-header-col-body-label">نوع دارو</span>
                                        </div>

                                        <div className="follow-card-body-header-col-body-item">
                                            <span className="follow-card-body-header-col-body-value">{parseOtc(p.otc[index].name).d_unit}</span>
                                            <span className="follow-card-body-header-col-body-label">بسته بندی</span>
                                        </div>

                                        <div className="follow-card-body-header-col-body-item">
                                            <span className="follow-card-body-header-col-body-value">{parseOtc(p.otc[index].name).d_count}</span>
                                            <span className="follow-card-body-header-col-body-label">تعداد</span>
                                        </div>

                                        <div className="follow-card-body-header-col-body-item">
                                            <span className="follow-card-body-header-col-body-value">{parseOtc(p.otc[index].name).d_desc}</span>
                                            <span className="follow-card-body-header-col-body-label">توضیحات</span>
                                        </div>

                                    </div>:null}
                                </div>

                                <div className="follow-card-body-header-col">
                                    {p.files[index]?
                                        <div className="follow-card-body-header-col-body">

                                            <div className="follow-card-body-header-col-body-item">
                                                <Zoom>
                                                    <img src={p.files[index].file} alt=""/>
                                                </Zoom>
                                            </div>

                                            <div className="follow-card-body-header-col-body-item">
                                                <span className="follow-card-body-header-col-body-value">{p.files[index].description}</span>
                                                <span className="follow-card-body-header-col-body-label">توضیحات</span>
                                            </div>

                                        </div>:null}
                                </div>

                                <div className="follow-card-body-header-col">

                                    {p.e_prescription[index]?
                                        <div className="follow-card-body-header-col-body">

                                            <div className="follow-card-body-header-col-body-item">
                                                <span className="follow-card-body-header-col-body-value">{p.e_prescription[index].insurance_type}</span>
                                                <span className="follow-card-body-header-col-body-label">نوع بیمه</span>
                                            </div>

                                            <div className="follow-card-body-header-col-body-item">
                                                <span className="follow-card-body-header-col-body-value">{p.e_prescription[index].national_code}</span>
                                                <span className="follow-card-body-header-col-body-label">کد ملی</span>
                                            </div>

                                            <div className="follow-card-body-header-col-body-item">
                                                <span className="follow-card-body-header-col-body-value">{p.e_prescription[index].prescription_id}</span>
                                                <span className="follow-card-body-header-col-body-label">کد رهگیری</span>
                                            </div>

                                            <div className="follow-card-body-header-col-body-item">
                                                <span className="follow-card-body-header-col-body-value">{p.e_prescription[index].dr_name}</span>
                                                <span className="follow-card-body-header-col-body-label">نام پزشک</span>
                                            </div>

                                            <div className="follow-card-body-header-col-body-item">
                                                <span className="follow-card-body-header-col-body-value">{p.e_prescription[index].description}</span>
                                                <span className="follow-card-body-header-col-body-label">توضیحات</span>
                                            </div>

                                        </div>:null}


                                </div>

                            </div>
                        )
                    })}


                </div>
            </Expand>



        </div>
    )

}


function MedCard({p,generateDescFromPrescription,del,mId}) {

    console.log("gener :",p)

    const [currentDetail, set_currentDetail] = useState({});
    const [spin, set_spin] = useState(false);
    const [isCouponModalVisible, setIsCouponModalVisible] = useState(false);

    const history = useHistory()

    const showModal = () => {
        setIsCouponModalVisible(true);
    };

    const handleOk = () => {
        setIsCouponModalVisible(false);
    };

    const handleCancel = () => {
        setIsCouponModalVisible(false);
    };


    const finalizedMed = async (p)=> {

        //set address

        let non_delivery = deliverType==="none"

        try{
            const res = await finialMedOrder_api(p.uid,non_delivery)

            let f = res.data.invoice;

            try {
                //create invoice
                let req = {
                    amount: f.payable_amount,
                    client_callback: window.location.origin+"/dr-shop/bank-result/"+f.uid,
                    res_num: f.uid,
                    merchant_uid: f.merchant.uid
                }
                const response = await StoreOnlineCreateInvoice(req);
                history.push(`/dr-shop/pay/${f.merchant.uid}`, {create: response.data,finalObj:{invoice:f}})
                // history.push(`/dr-shop/preinvoice/${f.merchant.uid}`, {create: response.data})
            } catch (e) {
                // console.log(e)
                return
            }

        }catch (e) {

            console.log(e)
        }

    }

    // const directPay = async (f)=>{
    //     console.log("f",f)
    //
    //     try {
    //         //create invoice
    //         let req = {
    //             amount: f.payable_amount,
    //             client_callback: window.location.origin+"/dr-shop/bank-result/"+f.uid,
    //             res_num: f.uid,
    //             merchant_uid: f.merchant.uid
    //         }
    //         const response = await StoreOnlineCreateInvoice(req);
    //         history.push(`/dr-shop/pay/${f.merchant.uid}`, {create: response.data,finalObj:{invoice:f}})
    //         // history.push(`/dr-shop/preinvoice/${f.merchant.uid}`, {create: response.data})
    //     } catch (e) {
    //         // console.log(e)
    //         return
    //     }
    // }


    const [deliverType,set_deliverType] = useState("courier")

    return(
        <div className="prescription-body-pItem">


            <Modal visible={isCouponModalVisible}  footer={null}   onOk={handleOk} onCancel={handleCancel}>


                <Spin spinning={spin}>
                    <div className="request-detail-modal">
                        <div className="request-detail-modal-header">
                            <div className="request-detail-modal-header-title" >
                                <span>آدرس خود را انتخاب نمایید : </span>
                            </div>
                            {mId?<OnlineMedAddress merchantId={mId} medId={p.uid}/>:null}
                        </div>

                        <div className="request-detail-modal-header">
                            <div className="request-detail-modal-header-title" >
                                <span>نوع تحویل را انتخاب نمایید : </span>
                            </div>
                            <div className="deliver-sec">

                                <div className="deliver-item" onClick={e=>{set_deliverType("none")}}>
                                    <span>حضوری</span>
                                    <input type="radio" name="delivery" id="" placeholder="" checked={deliverType==="none"}/>
                                </div>

                                <div className="deliver-item" onClick={e=>{set_deliverType("courier")}}>
                                    <span>پیک</span>
                                    <input type="radio" name="delivery" id="" placeholder="" checked={deliverType==="courier"}/>
                                </div>

                            </div>


                        </div>

                        <div className="request-detail-modal-body">
                            <MedC med={p}/>
                        </div>

                        <div className="med-detail-modal-footer">


                            <div className="med-detail-modal-footer-row">
                                <span className="med-detail-modal-footer-row-value">{numberWithCommas(p.total_discount)} ریال</span>
                                <span className="med-detail-modal-footer-row-label">تخفیف </span>
                            </div>

                            <div className="med-detail-modal-footer-row">
                                <span className="med-detail-modal-footer-row-value">{numberWithCommas(p.tech_cost)} ریال</span>
                                <span className="med-detail-modal-footer-row-label">حق فنی </span>
                            </div>


                            <div className="med-detail-modal-footer-row">
                                <span className="med-detail-modal-footer-row-value">{numberWithCommas(p.total_amount)} ریال</span>
                                <span className="med-detail-modal-footer-row-label">مبلغ قابل پرداخت</span>
                            </div>

                        </div>



                        <div className="med-detail-modal-footer-btns">
                            <div className="med-detail-modal-footer-btn-accept" onClick={e=>{
                                finalizedMed(p)
                            }}>
                                <span>مشاهده فاکتور</span>
                            </div>
                            {/*<div className="med-detail-modal-footer-btn-reject" onClick={e=>{*/}
                            {/*    // rejectMedOrder()*/}
                            {/*}}>*/}
                            {/*    <span>رد کردن</span>*/}
                            {/*</div>*/}
                        </div>

                    </div>
                </Spin>


            </Modal>

            <div className="prescription-body-pItem-info">
                <div className="prescription-body-pItem-title">
                    <span>{moment(
                        p.created
                    ).format(
                        "HH:mm - jYYYY/jMM/jDD"
                    )}</span>

                </div>
                <div className="med-body-pItem-description">
                    {p.e_prescription.map(e=>{
                        return(
                            <span>{`کد ملی : ${e.national_code}/کد رهگیری :${e.prescription_id}/نام پزشک :${e.dr_name}`}</span>
                        )
                    })}

                    {p.files.map(e=>{
                        return(
                            <img src={e.file} alt=""/>
                        )
                    })}


                    {p.otc.map(e=>{
                        return(
                            <span>{e.name}</span>
                        )
                    })}


                    {/*{p.e_prescription?<span>{p.e_prescription}</span>:null}*/}
                    {/*{p.otc_prescription?<span>{p.otc_prescription}</span>:null}*/}
                    {/*{p.image_prescription?<img src={p.image_prescription} alt=""/>:null}*/}
                </div>
            </div>


            {p.order_status && p.order_status[0] && p.order_status[0]>2?
                <div className="med-body-pItem-status" style={{backgroundColor:convertOrderStatusColor(p.order_status[0])}}>
                        <span>{convertStatusCode(p.order_status[0])}</span>
                </div>:<div className="med-body-pItem-status" style={{backgroundColor:convertTicketStatusColor(p.status)}}>
                        <span>{convertTicketStatus(p.status)}</span>
                </div>}




            {p.order_status && p.order_status[0] && p.order_status[0]>2?
                <div></div>
            :
                <div>
                    {p.status===2 || p.status===3?<div className="med-pay-btn" onClick={e=>{
                        showModal(p)
                    }} >
                        <span> پرداخت  {numberWithCommas(p.total_amount)} ریال </span>
                    </div>:null}
                </div>
            }




        </div>
    )
}



function OrderPicCard({p,generateDescFromPrescription,del,index}) {

    const confirm = (e) => {
        console.log(e);
        del(p.id)
        // message.success('Click on Yes');
    };
    const cancel = (e) => {
        console.log(e);
        // message.error('Click on No');
    };


    return(
        <div className="prescription-e-card">

            <div className="prescription-e-card-delete">
                <Popconfirm
                    title="آیا شما از حذف مطمئن هستید ؟"
                    onConfirm={confirm}
                    onCancel={cancel}
                    okText="بله"
                    cancelText="خیر"
                >
                    <img src={TrashIcon} alt=""/>
                </Popconfirm>
            </div>

            <div className="prescription-e-card-body">

                <div className="prescription-pic-sec">
                    <img src={p.imageData} alt=""/>
                    <span> تصویر نسخه بارگذاری شده </span>
                </div>



            </div>

            <div className="prescription-pic-card-title">
                <span>{index+1}</span>
                <span>نسخه کاغذی</span>
            </div>



        </div>
    )

}




// function MedAddressCard({p,generateDescFromPrescription,del,index,mId,addressList}) {
//
//
//     return(
//         <div className="prescription-e-card">
//
//             <div className="prescription-remember-card-address">
//
//                 <div className="prescription-remember-card-address-row">
//
//
//
//                     <div className="prescription-remember-card-address-add-btn">
//                         <div className="prescription-remember-card-address-add-wr clickable">
//                             <img src={GreenPlusIcon} alt=""/>
//                             <span>افزودن آدرس</span>
//                         </div>
//
//                     </div>
//
//                     <div className="prescription-remember-card-address-info">
//                         <span>آدرس خود را انتخاب نمایید :</span>
//                         <div className="prescription-remember-card-address-list">
//
//                             {addressList.map(a=>{
//                                 return(
//                                     <div className="prescription-remember-card-address-item clickable" onClick={e=>{
//                                         set_selectedAddress(a.uid)
//                                     }}>
//                                         <span>{a.address}</span>
//                                         <input type="radio" checked={a.uid===selectedAddress}  id=""/>
//                                     </div>
//                                 )
//                             })}
//
//
//                         </div>
//                     </div>
//
//                 </div>
//
//                 <div className="prescription-remember-card-address-hint">
//                     <p>داروخانه بعد از بررسی سفارش شما و بنا بر آدرس و اقلامی که درخواست آنها را داشته اید مناسب ترین روش ارسال را در نظر گرفته و هزینه های سفارش جهت پرداخت به شما اعلام می گردد .
//                         می توانید از طریق همین صفحه و گزینه ی “پیگیری سفارشات” آخرین وضعیت درخواست خود را مشاهده نمایید.</p>
//                 </div>
//
//
//             </div>
//
//             <div className="prescription-remember-card-title">
//                 <span>آدرس</span>
//             </div>
//
//         </div>
//     )
//
// }


function RememberCard({p,generateDescFromPrescription,del,index,addRememberItem}) {

    const confirm = (e) => {
        console.log(e);
        del(p.id)
        // message.success('Click on Yes');
    };
    const cancel = (e) => {
        console.log(e);
        // message.error('Click on No');
    };

    const ref = useRef(null);

    return(
        <div className="prescription-e-card">

            <div className="remember-regal">
                <SwiperId ref={ref} {...imageParamss}>
                    {remember_list.map(r=>{
                        return(
                            <div className="remember-regal-card">
                                <img className="remember-image" src={r.image} alt=""/>
                                <span>{r.drug_name}</span>
                                <div className="add-btn clickable" onClick={e=>{
                                    addRememberItem(r)
                                }}>
                                    <PlusOutlined />
                                </div>
                            </div>
                        )
                    })}

                </SwiperId>
            </div>
            <div className="prescription-remember-card-title">
                <span>!  یادت نره  </span>
            </div>



        </div>
    )

}



function OrderOtcCard({p,generateDescFromPrescription,del,index}) {

    const confirm = (e) => {
        console.log(e);
        del(p.id)
        // message.success('Click on Yes');
    };
    const cancel = (e) => {
        console.log(e);
        // message.error('Click on No');
    };


    return(
        <div className="prescription-e-card">

            <div className="prescription-e-card-delete">
                <Popconfirm
                    title="آیا شما از حذف مطمئن هستید ؟"
                    onConfirm={confirm}
                    onCancel={cancel}
                    okText="بله"
                    cancelText="خیر"
                >
                    <img src={TrashIcon} alt=""/>
                </Popconfirm>
            </div>

            <div className="prescription-e-card-body">

               <div className="otc-sec">
                   <div className="otc-card-row">

                       <div className="otc-card-col">
                           <div className="e-card-form-item">
                               <span className="e-card-form-item-value">{p.drug_count}</span>
                               <span className="e-card-form-item-label">تعداد</span>
                           </div>

                           <div className="e-card-form-item">
                               <span className="e-card-form-item-value">{p.drug_dose}</span>
                               <span className="e-card-form-item-label">دوز دارو</span>
                           </div>

                           <div className="e-card-form-item">
                               <span className="e-card-form-item-value">{p.description}</span>
                               <span className="e-card-form-item-label">توضیحات</span>
                           </div>
                       </div>

                       <div className="otc-card-col">
                           <div className="e-card-form-item">
                               <span className="e-card-form-item-value">{p.drug_name}</span>
                               <span className="e-card-form-item-label">نام دارو</span>
                           </div>

                           <div className="e-card-form-item">
                               <span className="e-card-form-item-value">{p.drug_type}</span>
                               <span className="e-card-form-item-label">نوع دارو</span>
                           </div>

                           <div className="e-card-form-item">
                               <span className="e-card-form-item-value">{p.drug_unit}</span>
                               <span className="e-card-form-item-label">بسته بندی</span>
                           </div>
                       </div>
                   </div>

                   <div className="otc-card-similar">
                       <span>در صورت عدم موجودی داروی مشابه ارسال شود</span>
                       <input type="checkbox" name="" id=""/>
                   </div>
               </div>

            </div>

            <div className="prescription-otc-card-title">
                <span>{index+1}</span>
                <span>داروی بدون نسخه</span>
            </div>



        </div>
    )

}




function OrderECard({p,generateDescFromPrescription,del,index}) {


    if(p.insuranceType==="tamin"){
        p['insuranceType']= "تامین اجتماعی"
    }

    if(p.insuranceType==="salamat"){
        p['insuranceType']= "سلامت"
    }


    const confirm = (e) => {
        console.log(e);
        del(p.id)
        // message.success('Click on Yes');
    };
    const cancel = (e) => {
        console.log(e);
        // message.error('Click on No');
    };


    return(
        <div className="prescription-e-card">

            <div className="prescription-e-card-delete">
                <Popconfirm
                    title="آیا شما از حذف مطمئن هستید ؟"
                    onConfirm={confirm}
                    onCancel={cancel}
                    okText="بله"
                    cancelText="خیر"
                >
                    <img src={TrashIcon} alt=""/>
                </Popconfirm>
            </div>

            <div className="prescription-e-card-body">

                <div className="e-card-list">

                    <div className="e-card-item">
                        <span>نوع بیمه :</span>
                        <span>{p.insuranceType}</span>
                    </div>

                    <div className="e-card-form-item">
                        <span className="e-card-form-item-value">{p.national_code}</span>
                        <span className="e-card-form-item-label">کد ملی </span>
                    </div>

                    <div className="e-card-form-item">
                        <span className="e-card-form-item-value">{p.tracking_code}</span>
                        <span className="e-card-form-item-label">کد رهگیری</span>
                    </div>

                    <div className="e-card-form-item">
                        <span className="e-card-form-item-value">{p.doctor_name}</span>
                        <span className="e-card-form-item-label">نام پزشک</span>
                    </div>


                </div>

            </div>

            <div className="prescription-e-card-title">
                <span>{index+1}</span>
                <span>نسخه الکترونیک</span>
            </div>



        </div>
    )

}


function OrderCard({p,generateDescFromPrescription,del}) {

    const confirm = (e) => {
        console.log(e);
        del(p.id)
        // message.success('Click on Yes');
    };
    const cancel = (e) => {
        console.log(e);
        // message.error('Click on No');
    };


    return(
        <div className="prescription-body-pItem">

            <div className="prescription-body-pItem-info">
                <div className="prescription-body-pItem-title">
                    <span>{p.title}</span>
                </div>
                <div className="prescription-body-pItem-description">
                    {p.type==="otc" || p.type==="electronic"?
                        <span>{generateDescFromPrescription(p)}</span>:null
                    }
                    {p.type==="pic" ?
                        <ImagePrev  file={p.imageData}/>
                        :null
                    }
                </div>
            </div>

            <div className="prescription-body-pItem-edit">
                <Popconfirm
                    title="آیا شما از حذف مطمئن هستید ؟"
                    onConfirm={confirm}
                    onCancel={cancel}
                    okText="بله"
                    cancelText="خیر"
                >
                    <DeleteOutlined/>
                </Popconfirm>
            </div>
        </div>
    )

}

const ImagePrev = ({file})=>{

    const [prev,set_prev] = useState()


    return(
        <img style={{width:200}} src={file} alt=""/>
    )
}

function PrescriptionSec({item, LinkDispatcher}) {


    const fileRef = useRef()
    const history = useHistory()

    //meds
    const [meds,set_meds] = useState([])

    //orders
    const [prescriptions, set_prescriptions] = useState([])
    const [currentPrescription, set_currentPrescription] = useState([])
    const [activeTab, set_activeTab] = useState("default") // default | e-prescription | pic-prescription | otc

    //e-prescription
    const [insuranceType, set_insuranceType] = useState("tamin") // tamin | salamat
    const [national_code, set_national_code] = useState("")
    const [doctor_name, set_doctor_name] = useState("")
    const [tracking_code, set_tracking_code] = useState("")


    const [drug_name, set_drug_name] = useState("")
    const [drug_type, set_drug_type] = useState("قرص")
    const [drug_dose, set_drug_dose] = useState("")
    const [drug_count, set_drug_count] = useState("")
    const [drug_unit, set_drug_unit] = useState("ورق")
    const [desc, set_desc] = useState("")


    let prescriptionObj = {
        items: [
            {
                type: "otc", // otc | pic | electronic
                title: "",
                description: "",
                image: "",
                insuranceType: "",
                doctor_name: "",
                national_code: "",
                tracking_code: ""
            }
        ]
    }

    const addToCurrentPrescription = () => {
        switch (activeTab) {
            case "e-prescription":
                addEPrescription()
                break;
            case "pic-prescription":
                addPicPrescription()
                break;
            case "otc":
                addOtcPrescription()
                break;
        }
    }




    const resetPrescription = () => {
        set_insuranceType("tamin")
        set_national_code("")
        set_doctor_name("")
        set_tracking_code("")
        set_desc("")

        set_drug_name("")
        set_drug_count("")
        set_drug_unit("ورق")
        set_drug_dose("")
        set_drug_type("قرص")
        setDataFile("")

        setSelectedFile(null)
        setPreview(null)
    }

    const addPicPrescription = () => {
        // const exist = prescriptions.find(p => p.type === "pic")
        // if (exist)
        //     return message.error('این نوع نسخه اضافه شده است');

        if (!preview)
            return message.error('لطفا تصویر نسخه را بارگذاری نمایید');


        let obj = {
            type: "pic", // otc | pic | electronic
            title: "تصویر نسخه",
            id:makeid(7),
            description: desc,
            imageData:dataFile,
            image: selectedFile
        }

        try{
            set_prescriptions([...prescriptions, obj])
            let str = JSON.stringify([...prescriptions, obj])
            localStorage.setItem('prescriptions',str )
        }catch (e) {
            console.log(e)
        }

        resetPrescription()
        return message.success('نسخه به سفارش شما اضافه شد');


    }

    const addRememberItem = (r)=>{
        let obj = {
            type: "otc", // otc | pic | electronic
            title: "بدون نسخه",
            description: "",
            image: "",
            id:makeid(7),
            drug_name: r.drug_name,
            drug_count: r.drug_count,
            drug_unit: r.drug_unit,
            drug_type: r.drug_type,
            drug_dose: r.drug_dose
        }


        set_prescriptions([...prescriptions, obj])
        localStorage.setItem('prescriptions', JSON.stringify([...prescriptions, obj]))
        resetPrescription()
        return message.success('به سفارش شما اضافه شد');
    }

    const addOtcPrescription = () => {

        //validation

        // const exist = prescriptions.find(p => p.type === "otc")
        // if (exist)
        //     return message.error('این نوع نسخه اضافه شده است');

        if (drug_name.length < 1)
            return message.error('لطفا نام دارو را کامل نمایید');

        // if (drug_dose.length < 1)
        //     return message.error('لطفا دوز را کامل نمایید');

        if (drug_count.length < 1)
            return message.error('لطفا تعداد را کامل نمایید');


        let obj = {
            type: "otc", // otc | pic | electronic
            title: "بدون نسخه",
            description: desc,
            image: "",
            id:makeid(7),
            drug_name: drug_name,
            drug_count: drug_count,
            drug_unit: drug_unit,
            drug_type: drug_type,
            drug_dose: drug_dose
        }


        set_prescriptions([...prescriptions, obj])
        localStorage.setItem('prescriptions', JSON.stringify([...prescriptions, obj]))
        resetPrescription()
        return message.success('نسخه به سفارش شما اضافه شد');



    }

    const addEPrescription = () => {

        //validation

        // const exist = prescriptions.find(p => p.type === "electronic")
        // if (exist)
        //     return message.error('این نوع نسخه اضافه شده است');

        if (national_code.length < 1)
            return message.error('لطفا کدملی را کامل نمایید');

        if (tracking_code.length < 1)
            return message.error('لطفا کدرهگیری را کامل نمایید');

        // if (doctor_name.length < 1)
        //     return message.error('لطفا نام پزشک را کامل نمایید');

        if (insuranceType === "salamat" && tracking_code.length < 1)
            return message.error('لطفا کد رهگیری را کامل نمایید ');

        let obj = {
            type: "electronic", // otc | pic | electronic
            title: "نسخه الکترونیک",
            description: desc,
            id:makeid(7),
            image: "",
            insuranceType: insuranceType,
            doctor_name: doctor_name,
            national_code: national_code,
            tracking_code: tracking_code
        }
        set_prescriptions([...prescriptions, obj])
        localStorage.setItem('prescriptions', JSON.stringify([...prescriptions, obj]))
        resetPrescription()
        return message.success('نسخه به سفارش شما اضافه شد');
    }




    const changeTab = (name) => {
        set_activeTab(name)
    }

    const [selectedFile, setSelectedFile] = useState()
    const [dataFile, setDataFile] = useState("")
    const [preview, setPreview] = useState()


    // create a preview as a side effect, whenever selected file is changed
    useEffect(() => {
        if (!selectedFile) {
            setPreview(undefined)
            return
        }

        dataUrl(selectedFile)
        const objectUrl = URL.createObjectURL(selectedFile)
        setPreview(objectUrl)

        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl)
    }, [selectedFile])


    const dataUrl = async (f)=>{
        let data = await toBase64(f)
        setDataFile(data)
    }

    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    });

    useEffect(()=>{
        let localP = localStorage.getItem('prescriptions')
        if(localP) {
            set_prescriptions(JSON.parse(localP))
        }
    },[])


    useEffect(()=>{
        getMerchant()
        getAddress()
    },[])

    const [merchant,set_merchant] = useState(null)
    const [addressList,set_addressList] = useState([])

    const getMerchant = async ()=>{
        try{
            const mer = await getMallMerchant_api()
            merchantId = mer.data.uid
            getMeds()
            set_merchant(mer.data)
        }catch (e) {
            console.log(e)
        }
    }

    const [selectedAddress,set_selectedAddress] = useState("");

    const getAddress = async ()=>{
        try{
            const mer = await getAddressMedOrder_api()
            set_addressList(mer.data)
            if(mer.data.length>0){
                set_selectedAddress(mer.data[0].uid)
            }
        }catch (e) {
            console.log(e)
        }
    }





    const getMeds =  async ()=>{
        try{
            const res= await getMeds_api(page,merchantId);
            set_meds(res.data.results)
            set_total(res.data.count)
        }catch (e) {
            console.log(e)
        }
    }

    const handleFileChange = (e) => {

        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFile(undefined)
            return
        }

        // I've kept this example simple by using the first image instead of multiple
        setSelectedFile(e.target.files[0])

    }

    const handleClickOnFile = () => {
        fileRef.current.click();
    }


    const generateDescFromPrescription = (p) => {
        switch (p.type) {
            case "otc":
                return generateOtcDescription(p)
                break;
            case "electronic":
                return generateElectronicDescription(p)
                break;
            default:
                return ""
        }
    }

    const deletePrescriptionFromOrder = (id)=>{
        let filtered = prescriptions.filter(p=>p.id!==id)
        set_prescriptions(filtered)
        console.log("filtered",filtered)
        localStorage.setItem("prescriptions",JSON.stringify(filtered))
    }



    const generateElectronicDescription = (p)=>{
        console.log("",p.insuranceType)
        if(p.insuranceType==="tamin"){
            p['insuranceType']= "تامین اجتماعی"
        }

        if(p.insuranceType==="salamat"){
            p['insuranceType']= "سلامت"
        }

        return "نام پزشک :"+p.doctor_name+"/"+"کد ملی : "+p.national_code+"/"+"کد رهگیری  : "+p.tracking_code+"/"+"نوع بیمه :"+p.insuranceType
    }

    const generateOtcDescription = (p)=>{
        return "نام دارو :"+p.drug_name+"/"+"تعداد دارو :"+p.drug_count+"/"+"واحد دارو :"+p.drug_unit+"/"+"نوع دارو :"+p.drug_type+"/"+"دوز دارو :"+p.drug_dose+"/"+"توضیحات دارو :"+p.description
    }


    function dataURLtoBlob(dataURL) {
        let byteString = atob(dataURL.split(',')[1]);
        let mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
        let ab = new ArrayBuffer(byteString.length);
        let ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    }

    const [final_add_spin,set_final_add_spin] = useState(false)

    const finalizeAddOrder = async ()=>{

        set_final_add_spin(true)
        if(selectedAddress.length<1){
            return message.error('لطفا یک آدرس وارد نمایید');
        }

        try{
            const mer = await getMallMerchant_api()


            // let obj = {
            //     otc_prescription:"",
            //     file:"",
            //     e_prescription:""
            // }
            //
            // let otc = prescriptions.find(p=>p.type==="otc")
            // let pic = prescriptions.find(p=>p.type==="pic")
            // let electronic = prescriptions.find(p=>p.type==="electronic")
            //
            //
            //
            //
            //
            // if(otc)
            //     obj['otc_prescription'] = generateOtcDescription(otc)
            //
            // if(electronic)
            //     obj['e_prescription'] = generateElectronicDescription(electronic)
            //
            // if(pic)
            //     obj['file'] = pic.image
            //
            //



            let obj_p = {
                merchant_uid:mer.data.uid,
                otc:prescriptions.filter(f=>f.type==="otc").map(p=> {
                    return {name: generateOtcDescription(p),description:p.description}
                }),

                files:prescriptions.filter(f=>f.type==="pic").map(p=> {
                    return {file:p.imageData,description:p.description}
                }),

                e_prescription:prescriptions.filter(f=>f.type==="electronic").map(p=> {
                    return {
                        national_code: p.national_code,
                        dr_name: p.doctor_name,
                        prescription_id: p.tracking_code,
                        description:p.description,
                        insuranceType:p.insuranceType
                    }
                })

            }

            console.log("vvvvvvvvvvvv :",obj_p)

            if(obj_p.files.length<1)
                delete obj_p.files

            if(obj_p.e_prescription.length<1)
                delete obj_p.e_prescription

            if(obj_p.otc.length<1)
                delete obj_p.otc

            obj_p['address'] = selectedAddress

            let med = await createmedOrder_api(obj_p,selectedAddress)
            set_final_add_spin(false)
            // await ChangeDefaultMedAddress(selectedAddress,mer.data.uid,med.data.uid)
            set_prescriptions([])
            localStorage.removeItem("prescriptions")
            return message.success('سفارش شما با موفقیت ثبت شد');
        }catch (e) {
            set_final_add_spin(false)
            console.log(e)
            return message.error('مشکل در ثبت سفارش');
        }

    }


    const [total,set_total] = useState(0)

    const handleOnchangePage = (p,size)=>{
        console.log(p,size)
        page = p;
        getMeds()
    }

    const onChange = (key) => {
        console.log(key);
    };




    return (
        <div style={{margin: "20px 16px 0 16px"}}>



            <div className="prescription-container">
                <input
                    style={{display: "none"}}
                    ref={fileRef}
                    type="file" name="" id="" onChange={handleFileChange}/>

                <div className="prescription-header-visit-order-btn" onClick={e => {
                    getMeds()
                    set_activeTab("track")
                    console.log(prescriptions)
                }}>
                    <span>پیگیری سفارشات </span>
                    {/*<div className="prescription-header-tracking-badge">*/}
                    {/*    <span>3</span>*/}
                    {/*</div>*/}
                </div>

                {/*Header*/}
                <div className="prescription-header">

                    <div className="prescription-header-title">
                        <img src={CapDrugIcon} alt=""/>
                        <span>ثبت سفارش جدید</span>
                        <img src={TabDrugIcon} alt=""/>
                    </div>

                    {/*<div className="prescription-header-address">*/}
                    {/*    /!*<span className="prescription-header-address-label">آدرس  :</span>*!/*/}
                    {/*    /!*<span className="prescription-header-address-path">تهران - طرشت - خ قاسمی - خ صادقی</span>*!/*/}
                    {/*</div>*/}



                    {/*<div className="prescription-header-title">*/}
                    {/*    <span>داروی خود را سفارش دهید</span>*/}
                    {/*</div>*/}

                </div>


                {/*Tabs*/}
                <div className="prescription-tabs">


                    <div className={activeTab === "list" ? "prescription-tabs-item active" : "prescription-tabs-item"}
                         onClick={e => changeTab("list")}>
                        {prescriptions.length>0?
                            <span className="med-basket-badge">{prescriptions.length}</span>:
                            null
                        }

                        <span>سبد سفارش شما</span>
                        <img src={SmallGreenBasketIcon} alt=""/>
                    </div>

                    <div className={activeTab === "otc" ? "prescription-tabs-item active" : "prescription-tabs-item"}
                         onClick={e => changeTab("otc")}>
                        <span>افزودن داروهای بدون نسخه</span>
                        <img src={GreenPlusIcon} alt=""/>
                    </div>

                    <div
                        className={activeTab === "pic-prescription" ? "prescription-tabs-item active" : "prescription-tabs-item"}
                        onClick={e => changeTab("pic-prescription")}>
                        <span>افزودن نسخه کاغذی</span>
                        <img src={GreenPlusIcon} alt=""/>
                    </div>

                    <div
                        className={activeTab === "e-prescription" ? "prescription-tabs-item active" : "prescription-tabs-item"}
                        onClick={e => changeTab("e-prescription")}>
                        <span>افزودن نسخه الکترونیک</span>
                        <img src={GreenPlusIcon} alt=""/>
                    </div>

                </div>


                {/*Body*/}
                {activeTab!=="track"?
                    <div className="prescription-body">

                        {activeTab === "default" ?
                            <div className="prescription-body-default">
                                <div className="prescription-body-default-title">
                                    <span>راهنمای ثبت سفارش </span>
                                </div>

                                <div className="prescription-body-default-row">
                                    <span> جستجو و ارسال سفارش شما ممکن است بیش از سه ساعت زمان ببرد، این سرویس برای سفارش در شرایط اورژانسی نیست.</span>
                                </div>

                                <div className="prescription-body-default-row">
                                    <span>سرویس تهیه دارو در شهرهای تهران، مشهد، اصفهان، تبریز، کرج، رشت، ارومیه، اهواز، شیراز، قم  در دسترس است. </span>
                                </div>

                                <div className="prescription-body-default-row">
                                    <span>پس از تایید نسخه و‌ یا اقلام دارویی شما توسط داروخانه ، براساس قوانین و‌ مقررات فنی داروخانه‌ها، هزینه نسخه برای شما پیامک می‌شود.</span>
                                </div>

                                <div className="prescription-body-default-row">
                                    <span>ممکن است اصل نسخه فیزیکی توسط داروخانه درخواست شود. در این صورت پیک ابتدا نسخه شما را دریافت و پس از ارائه به داروخانه، داروی شما تحویل می‌گردد.</span>
                                </div>

                            </div>
                            : null}




                        {activeTab === "otc" ?

                            <div className="v2-e-prescription">

                                <div className="v2-e-prescription-col">

                                    <div className="add-to-basket-btn" onClick={e=>{
                                        addToCurrentPrescription()
                                    }}>
                                        <div className="add-to-basket-btn-img">
                                            <img src={GreenPlusIcon} alt=""/>
                                            <img className="basket-icon" src={GreenBasketIcon} alt=""/>
                                        </div>
                                        <div className="add-to-basket-btn-text">
                                            <span>افزودن به سبد</span>
                                        </div>

                                    </div>
                                </div>

                                <div className="v2-e-prescription-col">

                                    <div className="v2-e-prescription-input">
                                        <input
                                            value={drug_count}
                                            onChange={e => {
                                                set_drug_count(e.target.value);
                                            }}
                                            type="text" placeholder="مثال : 20"/>
                                        <span>تعداد</span>
                                    </div>

                                    <div className="v2-e-prescription-input">
                                        <input
                                            value={drug_dose}
                                            onChange={e => {
                                                set_drug_dose(e.target.value);
                                            }}
                                            type="text" placeholder="مثال : 50"/>
                                        <span>دوز دارو</span>
                                    </div>

                                    <div className="v2-e-prescription-input">
                                        <textarea
                                            value={desc}
                                            onChange={e => {
                                                set_desc(e.target.value);
                                            }}
                                            type="text" name="" id="" placeholder="مثال : نام شرکت سازنده یا برند"></textarea>
                                        <span>توضیحات</span>
                                    </div>

                                </div>

                                <div className="v2-e-prescription-col">



                                    <div className="v2-e-prescription-input">
                                        <input
                                            value={drug_name}
                                            onChange={e => {
                                                set_drug_name(e.target.value);
                                            }}
                                            type="text" placeholder="نام دارو"/>
                                        <span><span className="required"></span>نام دارو</span>

                                    </div>

                                    <div className="v2-e-prescription-select">
                                        <select
                                            value={drug_type}
                                            onChange={e => {
                                                set_drug_type(e.target.value);
                                            }}
                                            name="" id="" placeholder="نوع دارو">
                                            <option value="قرص">قرص</option>
                                            <option value="شربت">شربت</option>
                                            <option value="کرم">کرم</option>
                                        </select>
                                        <span><span className="required"></span>نوع دارو </span>
                                    </div>

                                    <div className="v2-e-prescription-select">
                                        <select
                                            value={drug_unit}
                                            onChange={e => {
                                                set_drug_unit(e.target.value);
                                            }}
                                            name="" id="" placeholder="انتخاب واحد">
                                            <option value="ورق">ورق</option>
                                            <option value="بسته">بسته</option>
                                            <option value="بطری">بطری</option>
                                        </select>
                                        <span><span className="required"></span>بسته بندی </span>
                                    </div>

                                </div>
                            </div>

                            :null
                        }







                        {activeTab === "pic-prescription" ?
                            <div className="v2-e-prescription">

                                <div className="v2-e-prescription-col">

                                    <div className="add-to-basket-btn" onClick={e=>{
                                        addToCurrentPrescription()
                                    }}>
                                        <div className="add-to-basket-btn-img">
                                            <img src={GreenPlusIcon} alt=""/>
                                            <img className="basket-icon" src={GreenBasketIcon} alt=""/>
                                        </div>
                                        <div className="add-to-basket-btn-text">
                                            <span>افزودن به سبد</span>
                                        </div>

                                    </div>
                                </div>


                                <div className="v2-e-prescription-col c-1">

                                    <div className="v2-e-prescription-upload" onClick={e => {
                                        handleClickOnFile()
                                    }}>
                                        {!selectedFile && <img className="icon-upload" src={PhUploadIcon} alt=""/>}
                                        {selectedFile && <img className="prev-upload" src={preview}/>}
                                        <span>آپلود تصویر (دقت کنید عکس واضح و از بالا گرفته شده باشد)</span>
                                    </div>

                                    <div className="v2-e-prescription-input amend-col">
                                        <textarea
                                            value={desc}
                                            onChange={e => {
                                                set_desc(e.target.value);
                                            }}
                                            type="text" name="" id="" placeholder="مثال : نام شرکت سازنده یا برند"></textarea>
                                        <span>توضیحات</span>
                                    </div>

                                </div>
                            </div>

                            :null}







                        {activeTab === "e-prescription"?
                            <div className="v2-e-prescription">

                                <div className="v2-e-prescription-col">

                                    <div className="add-to-basket-btn" onClick={e=>{
                                        addToCurrentPrescription()
                                    }}>
                                        <div className="add-to-basket-btn-img">
                                            <img src={GreenPlusIcon} alt=""/>
                                            <img className="basket-icon" src={GreenBasketIcon} alt=""/>
                                        </div>
                                        <div className="add-to-basket-btn-text">
                                            <span>افزودن به سبد</span>
                                        </div>

                                    </div>
                                </div>

                                <div className="v2-e-prescription-col">

                                    <div className="v2-e-prescription-input">
                                        <input
                                            value={doctor_name}
                                            onChange={e => set_doctor_name(e.target.value)}
                                            type="text" name="" id="" placeholder="مثال : علی صالحی"/>
                                        <span>نام پزشک</span>
                                    </div>

                                    <div className="v2-e-prescription-input">
                                        <textarea
                                            value={desc}
                                            onChange={e => {
                                                set_desc(e.target.value);
                                            }}
                                            type="text" name="" id="" placeholder="مثال : نام شرکت سازنده یا برند"></textarea>
                                        <span>توضیحات</span>
                                    </div>

                                </div>

                                <div className="v2-e-prescription-col">

                                    <div className="v2-e-prescription-choose">
                                        <div className="v2-e-prescription-choose-title">
                                            <span className="required">*</span>
                                            <span className="label"> : نوع بیمه خود را انتخاب نمایید </span>
                                        </div>

                                        <div className="v2-e-prescription-choose-options">
                                            <div className="v2-e-prescription-choose-option">
                                                <span>تامین اجتماعی</span>
                                                <input type="radio" name="bim" id=""
                                                       onClick={e => set_insuranceType("tamin")}
                                                       checked={insuranceType === "tamin"}/>
                                            </div>

                                            <div className="v2-e-prescription-choose-option">
                                                <span>بیمه سلامت / خدمات درمانی</span>
                                                <input type="radio" name="bim" id=""
                                                       onClick={e => set_insuranceType("salamat")}
                                                       checked={insuranceType === "salamat"}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="v2-e-prescription-input">
                                        <input
                                            value={national_code}
                                            onChange={e => set_national_code(e.target.value)}
                                            type="text" name="" id="" placeholder="مثال : 0012233445"/>
                                        <span><span className="required">*</span>کد ملی</span>

                                    </div>

                                    <div className="v2-e-prescription-input">
                                        <input
                                            value={tracking_code}
                                            onChange={e => set_tracking_code(e.target.value)}
                                            type="text" name="" id="" placeholder="مثال : 26492"/>
                                        <span><span className="required">*</span>کد رهگیری</span>
                                    </div>

                                </div>
                            </div>
                            :null}







                        {activeTab === "list" ?
                            <div className="prescription-body-pList">

                                {prescriptions.map((p,index) => {
                                    return (
                                        <div>
                                            {p.type==="otc"?
                                                <OrderOtcCard
                                                    index={index}
                                                    p={p}
                                                    generateDescFromPrescription={generateDescFromPrescription}
                                                    del={deletePrescriptionFromOrder}
                                                />:null
                                            }
                                            {p.type==="pic"?
                                                <OrderPicCard
                                                    p={p}
                                                    index={index}
                                                    generateDescFromPrescription={generateDescFromPrescription}
                                                    del={deletePrescriptionFromOrder}
                                                />:null
                                            }
                                            {p.type==="electronic"?
                                                <OrderECard
                                                    p={p}
                                                    index={index}
                                                    generateDescFromPrescription={generateDescFromPrescription}
                                                    del={deletePrescriptionFromOrder}
                                                />:null
                                            }
                                        </div>

                                    )
                                })}

                                <RememberCard addRememberItem={addRememberItem}/>
                                {/*<MedAddressCard addressList={addressList} mId={merchant?.uid}/>*/}

                                <div className="prescription-e-card">

                                    <div className="prescription-remember-card-address">

                                        <div className="prescription-remember-card-address-row">



                                            <div className="prescription-remember-card-address-add-btn">
                                                <div className="prescription-remember-card-address-add-wr clickable" onClick={e=>{
                                                    history.push("/online-store-address")
                                                }}>
                                                    <img src={GreenPlusIcon} alt=""/>
                                                    <span>افزودن آدرس</span>
                                                </div>

                                            </div>

                                            <div className="prescription-remember-card-address-info">
                                                <span>آدرس خود را انتخاب نمایید :</span>
                                                <div className="prescription-remember-card-address-list">

                                                    {addressList.map(a=>{
                                                        return(
                                                            <div className="prescription-remember-card-address-item clickable" onClick={e=>{
                                                                set_selectedAddress(a.uid)
                                                            }}>
                                                                <span>{a.address}</span>
                                                                <input type="radio" checked={a.uid===selectedAddress}  id=""/>
                                                            </div>
                                                        )
                                                    })}


                                                </div>
                                            </div>

                                        </div>

                                        <div className="prescription-remember-card-address-hint">
                                            <p>داروخانه بعد از بررسی سفارش شما و بنا بر آدرس و اقلامی که درخواست آنها را داشته اید مناسب ترین روش ارسال را در نظر گرفته و هزینه های سفارش جهت پرداخت به شما اعلام می گردد .
                                                می توانید از طریق همین صفحه و گزینه ی “پیگیری سفارشات” آخرین وضعیت درخواست خود را مشاهده نمایید.</p>
                                        </div>


                                    </div>

                                    <div className="prescription-remember-card-title">
                                        <span>آدرس</span>
                                    </div>

                                </div>

                            </div>
                            : null}
                    </div>:null
                }


                {activeTab === "track" ?
                    <div className="prescription-body-pList">

                        {meds.map(p => {
                            return (
                                <FollowCard p={p} mId={merchant?.uid}/>
                                // <MedCard
                                //     p={p}
                                //     generateDescFromPrescription={generateDescFromPrescription}
                                //     del={deletePrescriptionFromOrder}
                                //     mId={merchant?.uid}
                                // />
                            )
                        })}

                        <Pagination defaultCurrent={1} onChange={handleOnchangePage}  total={total} />
                    </div>
                    : null}



                {/*{activeTab !== "default" && activeTab !== "list" ? <div className="prescription-add-to-order">*/}
                {/*    <span onClick={() => {*/}
                {/*        addToCurrentPrescription()*/}
                {/*    }}>افزودن به سفارش</span>*/}
                {/*</div> : null}*/}


                <Spin spinning={final_add_spin}>
                    {activeTab === "list" && prescriptions.length > 0? <div className="prescription-add-to-order" onClick={finalizeAddOrder}>
                        <span>تایید نهایی و ثبت سفارش</span>
                    </div> : null}
                </Spin>



            </div>

            {/*<Collapse*/}
            {/*    bordered={false}*/}
            {/*    defaultActiveKey={['2']} onChange={onChange}>*/}
            {/*    <Panel header="سفارش نسخه" key="1">*/}


            {/*        */}


            {/*    </Panel>*/}
            {/*</Collapse>*/}

        </div>
    )
}

export default PrescriptionSec
